import GlobalSearch from './GlobalSearch';

'use strict';
const PostTemplates = {

	// postTypes: ['posts', 'cpt_article', 'cpt_kosher_alert', 'cpt_restaurant', 'products'],
	placeholders: window.fwsPostPlaceholders,
	links: window.fwsPageLinks,

	renderArticles: (post) => {
		const authorHtml = post.author ? `
			<div class="search_results__item-author">
				<span class="search_results__item-author-icon">
					<span class="author-icon svg-icon">
						<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="currentColor">
							<path d="M149.6 234.4c20.9-6.7 43.2-10.4 66.4-10.4h80c13.3 0 24 10.7 24 24s-10.7 24-24 24h-80c-25.4 0-49.5 5.6-71 15.7C152.7 351 206.6 400 271.9 400h1c97.3-.5 191.1-100.3 191.1-243.4 0-12.8-.8-25.3-2.3-37.5C437 134.9 407.6 144 376 144H272c-57.6 0-106.3 38.1-122.4 90.4zm-53.2 25.7C102.5 168.5 178.8 96 272 96h104c28.7 0 54.8-10.8 74.6-28.5.7-.6 1.4-1.3 2.1-1.9 6.6-6.2 12.5-13.2 17.4-20.9 1.6-2.5 3.2-5.1 4.6-7.8 3.5-6.5 13.6-6.8 16.2.1 1.3 3.5 2.5 7 3.7 10.6 2.9 8.9 5.5 17.9 7.8 27.2.5 1.9.9 3.8 1.3 5.6 5.4 24.3 8.3 49.8 8.3 76.2 0 160.5-106.9 290.7-239 291.4h-1c-81.7 0-150.4-55.7-170.2-131.2C68.7 347.5 48 391.3 48 440v16c0 13.3-10.7 24-24 24S0 469.3 0 456v-16c0-75.1 38.3-141.2 96.4-179.9z"/>
						</svg>
					</span>
				</span>
				<span>Author: ${post.author}</span>
			</div>
		` : '';

		return `
			<a class="search_results__item" href="${post.permalink ? post.permalink : 'javascript:;'}">
				<div class="search_results__item-image">
					<img src="${post.image ? post.image : PostTemplates.placeholders.articles}" alt="Article Image" />
				</div>
				<div class="search_results__item-content">
					<h3 class="search_results__item-title pre-title pre-title--small">${post.title}</h3>
					<p class="search_results__item-description">${post.description}</p>
					${authorHtml}
				</div>
			</a>`;
	},

	renderAlerts: (post)=> {
		return `
			<a class="search_results__item" href="javascript:;">
				<div class="search_results__item-image">
					<img src="${post.image ? post.image : PostTemplates.placeholders.alerts}" alt="Alert Image" />
				</div>
				<div class="search_results__item-content">
					<h3 class="search_results__item-title pre-title pre-title--small">${post.title}</h3>
					<p class="search_results__item-description">${post.description}</p>
				</div>
			</a>
		`;
	},


	renderRestaurants: (post)=> {
		// Encode the value before constructing the URL
		const title = encodeURIComponent(post.title);
		return `
			<a class="search_results__item" href="${PostTemplates.links.restaurants ? PostTemplates.links.restaurants + '?searched_place=' + title : 'javascript:;'}">
				<div class="search_results__item-image">
					<img src="${post.image ? post.image : PostTemplates.placeholders.restaurants}" alt="Restaurant image" />
				</div>
				<div class="search_results__item-content">
					<h3 class="search_results__item-title pre-title pre-title--small">${post.title}</h3>
					<p class="search_results__item-description">${post.description}</p>
				</div>
			</a>
		`;
	},

	renderProducts: (post)=> {
		const count = post.count;
		const searchValue = GlobalSearch.$domSearchValue.val().trim();
		return `
			<div class="search_results__item search_results__item--product">
				<p class="search_results__item-title pre-title pre-title--small">${count > 0 ? ` There ${count < 2 ? 'is' : 'are'}<span class="item-count">&#160;${count}</span>&#160;${count < 2 ? 'product' : 'products'} for "${searchValue}",&#160;<a
					class="product-link moving-underline js-product-link" href="${PostTemplates.links.products ? PostTemplates.links.products + '?term=' + searchValue : 'javascript:;'}">click here to see ${count < 2 ? 'it' : 'them'}.</a>` : `No results were found for "${searchValue}"`}
				</p>
			</div>
		`;
	},

	renderNoResults: ()=> {
		const searchValue = GlobalSearch.$domSearchValue.val().trim();
		return `
			<div class="search_results__item search_results__item--no-results">
				<p class="search_results__item-title pre-title pre-title--small">No results were found for "${searchValue}"</p>
			</div>
		`;
	},

	renderPages: (post)=> {
		return `
			<a class="search_results__item" href="${post.permalink ? post.permalink : 'javascript:;'}">
				<div class="search_results__item-content">
					<h3 style="margin-bottom: 0px" class="search_results__item-title pre-title pre-title--small">${post.title}</h3>
				</div>
			</a>
		`;
	},
};

export default PostTemplates;
